class BaseExecutor {
    exec(methodName, incomingValues = null, defaultValue = null) {
        if (methodName in this) {
            return this[methodName]({incomingValues, defaultValue});
        }
        return defaultValue;
    }
}

export default BaseExecutor;
